import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DateTime } from 'luxon'
import { useRouteMatch } from 'react-router-dom'

import { useStores } from '@trivie/core'
import { TableHelper } from '../../../../tables'
import { TopicTable } from '../../../../tables/topic-table'

const Topics = observer(() => {
  const match = useRouteMatch<any>('/activities/assignments/:tab/:id/topics')
  const assignmentID = Number(match?.params?.id)
  const tab = String(match?.params?.id)

  const { assignmentStore } = useStores()
  const { assignmentOverviewStats, getAssignmentDetails } = assignmentStore

  useEffect(() => {
    if (!assignmentOverviewStats) {
      const endTime = DateTime.now()
      const startTime = endTime.plus({ days: -7 }).toISO().toString()
      getAssignmentDetails(assignmentID, startTime, endTime.plus({ days: -7 }).toISO())
    }
  }, [])

  const [tableHelper] = useState(
    new TableHelper('list_assignment_topics', 'topics', 'assignments', assignmentID, tab),
  )

  return <TopicTable tableHelper={tableHelper} />
})

export const AssignmentsTopicsTab = (props: any) => {
  const { id, mainTab } = props
  return {
    name: 'Topics',
    path: `/activities/assignments/${mainTab}/${id}/topics`,
    component: () => <Topics />,
  }
}
